<template>
      <div class="basket__list__block">
          <div class="basket__list">
              <div class="basket__list__img_l" @click="productId(cart_data_item.id)">
                <div class="basket__list__img">
                        <img :src="'https://ecodom04.com/backend/'+ cart_data_item.img" alt="image">
                </div>
                <div class="basket__list__text">
                    <h1>{{cart_data_item.title}}</h1>
                    <div class="basket__list__text_p" id="basket__list__text_p_scroll">
                        <p>
                            {{cart_data_item.description}}
                        </p>
                    </div>
                </div>
              </div>
              <div class="basket__list__btn">
                  <div class="basket__list__btn__price">
                      <p>
                          <span>{{cart_data_item.price | numeral('0,0')}}</span> ₸
                      </p>
                  </div>
                  <div class="basket__list__btn__remove">
                      <button @click="addToCart" class="add__basket">
                          <span class="mdi mdi-basket-fill"></span>
                          Добавить в корзину
                      </button>
                      <button @click="deleteFromFavorite">
                          <span class="mdi mdi-trash-can-outline"></span>
                          Удалить
                      </button>
                  </div>
              </div>
          </div>
      </div>
</template>

<script>
export default {
  name: 'cartitem',
  components: {
  },
  props: {
      cart_data_item: {
          type: Object,
          default (){
              return {}
          }
      }
  },
  methods: {
    productId(id) {
        this.$router.push({ name: 'ProductPage', params: { id: id }})
    },
    deleteFromFavorite() {
        this.$emit('deleteFromFavorite')
    },
    addToCart() {
        this.$emit('addToCart',{
            id: this.cart_data_item.id,
            img: this.cart_data_item.img,
            title: this.cart_data_item.title,
            price: this.cart_data_item.price,
            quantity: 1,
            oldprice: this.cart_data_item.price,
            description: this.cart_data_item.description,
        })
    }
  },
}
</script>
<style scoped lang="less">
@baseMedia: 900px;

    .basket__list__block {
        width: 90%;
        margin: 0 auto;
        margin-bottom: 15px;
        margin-top: 10px;
        border: 1px solid #ccc;
        border-radius: 5px;
        .basket__list {
            width: 100%;
            padding: 10px;
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #ccc;
            cursor: pointer;
            @media (max-width: @baseMedia) {
                justify-content: center;
                flex-wrap: wrap;
            }
            .basket__list__img_l {
                width: 77%;
                display: flex;
                justify-content: space-between;
                @media (max-width: @baseMedia) {
                     width: 100%;
                     justify-content: center;
                     flex-wrap: wrap;
                }
                .basket__list__img {
                    width: 23%;
                    text-align: center;
                    height: 150px;
                    @media (max-width: @baseMedia) {
                        width: 100%;
                        height: 100px;
                    }
                    overflow: hidden;
                    cursor: pointer;
                    img {
                        height: 100%;
                        
                        &:hover {
                            transition: 2s;
                            height: 110%;
                        }
                    }
                }
                .basket__list__text {
                    width: 75%;
                    padding-right: 10px;
                    h1 {
                        font-size: 20px;
                        @media (max-width: @baseMedia) {
                            font-size: 16px;
                        }
                    }
                    #basket__list__text_p_scroll::-webkit-scrollbar-track
                    {
                        background-color: transparent;
                    }

                    #basket__list__text_p_scroll::-webkit-scrollbar
                    {
                        width: 5px;
                    }

                    #basket__list__text_p_scroll::-webkit-scrollbar-thumb
                    {
                        background-color: #ccc;
                    }
                    @media (max-width: @baseMedia) {
                        width: 100%;
                    }
                    .basket__list__text_p {
                        width: 100%;
                        height: 125px;
                        overflow-y: scroll;
                        @media (max-width: @baseMedia) {
                            width: 100%;
                            height: auto;
                            margin-bottom: 10px;
                        }
                        p {
                            font-size: 15px;
                            margin-top: 15px;
                            @media (max-width: @baseMedia) {
                                margin-top: 7px;
                            }
                        }
                    }
                }
            }
            
            .basket__list__btn {
                width: 20%;
                @media (max-width: @baseMedia) {
                     width: 100%;
                }
                .basket__list__btn__price{
                     background: #fafaca;
                     width: 100%;
                     box-shadow: 0px 1px 6px 0px rgba(17,102,9,1);
                     padding-top: 5px;
                     padding-bottom: 5px;
                     p {
                         font-size: 20px;
                         color: #690;
                         text-align: center;
                         @media (max-width: @baseMedia) {
                            font-size: 16px;
                         }
                         span {
                             font-weight: bold;
                         }
                     }
                }
                .basket__list__btn__remove {
                    width: 100%;
                    margin-top: 10px;
                    
                    .add__basket {
                        background: #668800;
                    }
                    button {
                        background: #b70e27;
                        height: 35px;
                        width: 100%;
                        margin-bottom: 10px;
                        font-weight: bold;
                        color: #fff;
                        &:hover {
                            opacity: 0.7;
                        }
                        span {
                            color: #fff;
                        }
                        @media (max-width: @baseMedia) {
                            font-size: 14px;
                        }
                    }
                }
            }
        }
    }
</style>